<template>
    <div class="EquipmentAcceptanceDetails">
        <Box :title="$route.params.item?'资产修改':'资产登记'">
            <div class="tabs">
                <div v-for="(item, index) in ['基本信息','招标采购','合同信息','资金来源','折旧信息']"
                    :class="selectIndex === index ? 'action' : ''"
                    @click="selectIndex = index,$scrollscreen('.commonBox', 'start')">{{item}}</div>
            </div>
            <div class="contentBox">
                <div class="firstBox" key="firstBox" v-if="selectIndex === 0">
                    <Field title='使用科室' :action='true' type='manufacturer' placeholder='请选择' name='departmentList'
                        :text='data.SYKSMC' @manuconfirm='data.SYKSMC=arguments[0].b,data.SYKS=arguments[0].a' />

                    <Field title='资产名称' :action='true' type='manufacturer' placeholder='请选择'
                        name='EquipmentDictionariesNoText' :text='data.SBMC'
                        @manuconfirm='ValueChange(1,arguments[0])' />

                     <Field title='资产状态' :action='true' type='manufacturer' name='assetstates' placeholder='请选择'
                         :text='data.SBZTMC' @manuconfirm='data.SBZT=arguments[0].a,data.SBZTMC=arguments[0].b' />
                     <Field title='财务分类' :action='true' type='manufacturer' name='financeclassify' placeholder='请选择'
                         :text='data.CWKJKMMC' @manuconfirm='data.CWKJKM=arguments[0].a,data.CWKJKMMC=arguments[0].b' />
                     <Field title='资产来源' :action='true' type='manufacturer' name='SourcesOfAssets' placeholder='请选择'
                         :text='data.ZCLYMC' @manuconfirm='data.ZCLY=arguments[0].a,data.ZCLYMC=arguments[0].b' />
                     <Field title='资产编号' type='text' :text="data.SBBH" placeholder='系统自动生成' />

                    <!--这是新的内容-->
                    <Field title='原资产编号' type='input' maxlength='20' :text="data.YSBBH" placeholder='请输入' @onMessage="value=>data.YSBBH=value"/>
                    <Field title='条码号' type='input' maxlength='20' :text="data.TMH" placeholder='请输入' @onMessage="value=>data.TMH=value"/>






                    <Field title='规格型号' type='input' :text='data.SBXH' placeholder='请输入' @onMessage='e=>data.SBXH=e' />
                    <Field title='资产单位' type='input' :text='data.SBDW' placeholder='请输入' @onMessage='e=>data.SBDW=e' />


                    <Field title='财务编号' type='input' :text='data.CWBH' placeholder='请输入' @onMessage='e=>data.CWBH=e' />
                    <Field title='品牌' type='manufacturer' name='brand' placeholder='请选择' :text='data.SBPPMC'
                        @manuconfirm='data.SBPP=arguments[0].a,data.SBPPMC=arguments[0].b' />
                    <Field title='产地' type='manufacturer' name='areas' placeholder='请选择' :text='data.SBCDMC'
                        @manuconfirm='data.SBCD=arguments[0].a,data.SBCDMC=arguments[0].b' />
                    <Field title='国别' type='manufacturer' name='countries' placeholder='请选择' :text='data.SBGBMC'
                        @manuconfirm='data.SBGB=arguments[0].a,data.SBGBMC=arguments[0].b' />
                    <Field title='资产别名' type='input' placeholder='请输入' :text='data.DLMC' @onMessage='e=>data.DLMC=e' />
                    <Field title='注册证件号' type='input' placeholder='请输入' :text='data.ZCZJH'
                        @onMessage='e=>data.ZCZJH=e' />
                    <Field title='档案编号' type='input' placeholder='请输入' :text='data.YSBH' @onMessage='e=>data.YSBH=e' />
                    <Field title='资产序列号' type='input' placeholder='请输入' :text='data.SBXLH'
                        @onMessage='e=>data.SBXLH=e' />
                    <Field title='维修负责人' type='manufacturer' name='personnel_maintain' placeholder='请选择'
                        :text='data.WXFZRMC' @manuconfirm='data.WXFZR=arguments[0].a,data.WXFZRMC=arguments[0].b' />
                    <Field title='管理科室' type='manufacturer' name='departmentList' placeholder='请选择' :text='data.GLKSMC'
                        @manuconfirm='data.GLKS=arguments[0].a,data.GLKSMC=arguments[0].b' />
                    <Field title='存放地点' type='manufacturer' name='departmentList' placeholder='请选择' :text='data.CFDDMC==null?data.CFDD:data.CFDDMC'
                        @manuconfirm='data.CFDD=arguments[0].a,data.CFDDMC=arguments[0].b' />
                    <Field title='资产分类' type='manufacturer' name='equipmentClasses' placeholder='请选择'
                        :text='data.KJKMMC' @manuconfirm='data.KJKM=arguments[0].a,data.KJKMMC=arguments[0].b' />
                    <Field title='出厂编号' type='input' placeholder='请输入' :text='data.CCBH' @onMessage='e=>data.CCBH=e' />
                    <Field title="出厂日期" placeholder="请选择日期" :text="data.CCRQ==='1900-01-01'?'':data.CCRQ"
                        type="calendar" @onMessage="value => data.CCRQ = value" />
                     <Field title="有效期" placeholder="请输入1~10" :text="data.YXQ" type="number" name="digit"
                         @onMessage="value => data.YXQ = value" />

                    <Field title='资产类型' type='manufacturer' name='equipmentTypeList' placeholder='请选择'
                        :text='data.ZCLXMC' @manuconfirm='data.ZCLX=arguments[0].a,data.ZCLXMC=arguments[0].b' />
                    <Field title='资产使用人' type='manufacturer' name='personnel' placeholder='请选择' :text='data.ZYFZRMC'
                        @manuconfirm='data.ZYFZR=arguments[0].a,data.ZYFZRMC=arguments[0].b' />
                    <Field title='资产购置人' type='manufacturer' name='personnel' placeholder='请选择' :text='data.GZRMC'
                        @manuconfirm='data.GZR=arguments[0].a,data.GZRMC=arguments[0].b' />



                    <Field title='资产类别' type='manufacturer' name='DeviceClass' placeholder='请选择' :text='data.SFGDZCMC'
                        @manuconfirm='data.SFGDZCMC=arguments[0].b,data.SFGDZC=arguments[0].a' />


                    <Field title="进口信息" :tabSelected="data.ISDomestic" type="teb"
                        :data="[{id:'0',name:'国产'},{id:'1',name:'进口'},{id:'2',name:'未知'}]"
                        @onMessage="data.ISDomestic=arguments[0].id,data.ISDomesticMC=arguments[0].name" />
                    <Field title="附资产标志" :tabSelected="data.PJBZ" type="teb"
                        :data="[{id:'Y',name:'是'},{id:'N',name:'否'}]" @onMessage="data.PJBZ=arguments[0].id" />

                    <Field v-if="data.PJBZ==='Y'" title='主资产名称' :action='true' placeholder='请选择' type='manufacturer'
                        name='assetsList' :text='data.DDJXHMC'
                        @manuconfirm='data.DDJXH=arguments[0].a,data.DDJXHMC=arguments[0].b' />

                    <Field title="安装验收" :tabSelected="data.SFAZYS" type="teb"
                        :data="[{id:'1',name:'是'},{id:'0',name:'否'}]" @onMessage="data.SFAZYS=arguments[0].id" />
                    <Field title="有无发票" :tabSelected="data.YWFP" type="teb"
                        :data="[{id:'1',name:'有'},{id:'0',name:'无'}]" @onMessage="data.YWFP=arguments[0].id" />

                    <div v-if="data.YWFP==='1'">
                        <Field type='input' title='发票编号' placeholder='请输入' :text='data.FPBH'
                            @onMessage="e=>data.FPBH=e" />
                        <Field title='发票金额' placeholder='请输入' type='number' name='number' :text='data.FPJE'
                            @onMessage='e=>data.FPJE=e' />
                    </div>

                    <Field title="急救资产" :tabSelected="data.JJSBBZ" type="teb"
                        :data="[{id:'1',name:'是'},{id:'0',name:'否'}]" @onMessage="data.JJSBBZ=arguments[0].id" />
                    <Field title="特种资产" :tabSelected="data.TZSBBZ" type="teb"
                        :data="[{id:'1',name:'是'},{id:'0',name:'否'}]" @onMessage="data.TZSBBZ=arguments[0].id" />
                    <Field title="计量资产" :tabSelected="data.SFQJ" type="teb"
                        :data="[{id:'Y',name:'是'},{id:'N',name:'否'}]" @onMessage="data.SFQJ=arguments[0].id" />
                    <Field title="参与效益分析" :tabSelected="data.SFCYXYFX" type="teb"
                        :data="[{id:'Y',name:'是'},{id:'N',name:'否'}]" @onMessage="data.SFCYXYFX=arguments[0].id" />
                    <Field title="是否公用设备" :tabSelected="data.GYSB" type="teb"
                        :data="[{id:'1',name:'是'},{id:'0',name:'否'}]" @onMessage="data.GYSB=arguments[0].id" />
                    <Field title="管理类别" :tabSelected="data.GLLB" type="teb"
                        :data="[{id:'1',name:'I级'},{id:'2',name:'II级'},{id:'3',name:'III级'}]"
                        @onMessage="data.GLLB=arguments[0].id" />
                     <Field title="其他标志" :tabSelected="data.ZCBZ" type="teb"
                            :data="[{id:'',name:'暂无'},{id:'1',name:'TF'},{id:'2',name:'SY'}]"
                            @onMessage="data.ZCBZ=arguments[0].id" />

                     <Field title="风险等级" :tabSelected="data.RiskLevel" type="teb"
                            :data="[{id:1,name:'低风险'},{id:2,name:'中风险'},{id:3,name:'高风险'}]"
                            @onMessage="data.RiskLevel=arguments[0].id" />

                       <Field title="是否入账" :tabSelected="data.BYZD3" type="teb"
                             :data="[{id:'1',name:'是'},{id:'0',name:'否'}]"
                             @onMessage="data.BYZD3=arguments[0].id" />
                    <Field title='备注' type='textarea' :text='data.SBBZ' @onMessage='e=>data.SBBZ=e' />
                </div>
                <div class="secondBox" key="secondBox1" v-else-if="selectIndex === 1">
                    <Field title="采购方式" type="manufacturer" name="procurementmethod" placeholder='请选择'
                        :text="data.CGFSMC" @manuconfirm="data.CGFS=arguments[0].a,data.CGFSMC=arguments[0].b" />
                    <Field title="招标形式" type="manufacturer" name="thetenderform" placeholder='请选择' :text="data.ZBXSMC"
                        @manuconfirm="data.ZBXS=arguments[0].a,data.ZBXSMC=arguments[0].b" />
                    <Field title='单项预算' :text='data.DXYS' inputType='number' type='input' placeholder='请输入'
                        @onMessage='e=>data.DXYS=e' />
                    <Field title='立项依据' :text='data.LXYJ' type='textarea' placeholder='请输入'
                        @onMessage='e=>data.LXYJ=e' />
                </div>
                <div class="thirdlybox" key="thirdly" v-else-if="selectIndex === 2">
                    <Field title='合同价格' :action='true' inputType='number' type='input' placeholder='请输入'
                        :text='data.HTJG' @onMessage='e=>data.HTJG=e' />
                    <Field title="购入日期" placeholder="请选择日期" :text="data.GRRQ==='1900-01-01'?'':data.GRRQ"
                        type="calendar" @onMessage="e => data.GRRQ = e" />
                    <Field title="验收合格日期" :action='true' placeholder="请选择日期"
                        :text="data.QYRQ==='1900-01-01'?'':data.QYRQ" type="calendar" @onMessage="e => data.QYRQ = e" />
                    <Field title="保修到期" :action='true' placeholder="请选择日期" :DateMax='DateMax'
                        :text="data.ZZRQ==='1900-01-01'?'':data.ZZRQ" type="calendar" @onMessage="e => data.ZZRQ = e" />
                    <Field title="报检日期" placeholder="请选择日期" :text="data.BJRQ==='1900-01-01'?'':data.BJRQ"
                        type="calendar" @onMessage="value => data.BJRQ = value" />
                    <Field title="供应商" type="manufacturer" name="manufacturer" placeholder='请选择' :text="data.GYSMC"
                        @manuconfirm="ValueChange(2,arguments[0])" />
                    <Field title='联系人' type='input' :text='data.GYSLXR' placeholder='请输入'
                        @onMessage='e=>data.GYSLXR=e' />
                    <Field title='联系电话' type='input' :text='data.GYSDH' placeholder='请输入'
                        @onMessage='e=>data.GYSDH=e' />
                    <Field title="维修公司" type="manufacturer" name="maintain" placeholder='请选择' :text="data.WXGSMC"
                        @manuconfirm="ValueChange(3,arguments[0])" />
                    <Field title='联系人' type='input' :text='data.WXLXR' placeholder='请输入' @onMessage='e=>data.WXLXR=e' />
                    <Field title='维修电话' type='input' :text='data.WXDH' placeholder='请输入' @onMessage='e=>data.WXDH=e' />
                    <Field title="生产厂商" type="manufacturer" name="supplier" placeholder='请选择' :text="data.SBCJMC"
                        @manuconfirm="data.SBCJ=arguments[0].a,data.SBCJMC=arguments[0].b" />
                </div>
                <div class="fourthly" key="fourthly" v-else-if="selectIndex === 3">
                    <div class="fourthlyItems" v-for="item in AcceptInfo">
                        <div>
                            <span>{{item.name}}</span>
                            <input type="number" placeholder="请输入" v-model="item.JE">
                            <span>元</span>
                        </div>
                        <input type="text" placeholder="请输入备注内容" v-model="item.BZ" />
                    </div>
                </div>
                <div class="firstBox" key="firstBox" v-if="selectIndex === 4">
                    <Field title="折旧状态" :action='true' :tabSelected="data.ZJZT" type="teb"
                        :data="[{id:'1',name:'启用'},{id:'0',name:'不启用'}]" @onMessage="ZJZTChange(arguments[0])" />
                    <Field title='折旧起点' :action='true' placeholder="请输入" inputType='number' type="input"
                        :text='data.ZJQD=data.HTJG' @onMessage="e=>data.ZJQD=e" />
                    <Field title='当前净值' type='text' placeholder="系统自动计算" :text='data.SBJZ' />
                    <Field title="开始折旧日期" placeholder="请选择日期" :Isdisabled="data.ZJZT==='0'"
                        :text="data.KSZJRQ==='1900-01-01'?'':data.KSZJRQ" type="calendar"
                        @onMessage="e => data.KSZJRQ = e" />
                    <Field title='预计使用年限' placeholder="请输入(月)" :action='true' :type="data.ZJZT==='1'?'input':'text'"
                        inputType='number' :text='data.YJSYNX' @onMessage='e=>data.YJSYNX=e' />
                    <Field title='备注' type='textarea' :text='data.ZJBZ' @onMessage='e=>data.ZJBZ=e' />
                </div>
            </div>
            <Footer button="保存" @change="save" />
        </Box>
    </div>
</template>

<script>
    import Footer from '../../components/footer/footer'
    import {
        Cell,
        ActionSheet
    } from 'vant';
    import Box from '../../components/commonBox/commonBox'
    import Field from '../../components/field/field.vue'
    export default {
        name: 'PropertyEditDefault',
        data() {
            return {
                DateMax: new Date(new Date().getFullYear() + 10, '01', '01'),
                selectIndex: 0,
                data: this.$route.params.item ? { //Equipemnt信息
                } : {
                    ISDomestic: '0', //进口信息
                    PJBZ: 'N', //附资产标志
                    SFAZYS: '0', //是否安装验收
                    YWFP: '0', //有无发票
                    JJSBBZ: '0', //急救设备
                    TZSBBZ: '0', //特种资产
                    SFQJ: 'N', //计量资产
                    SFCYXYFX: 'N', //是否参与效益分析
                    GYSB: '0', //是否公用设备
                    ZJZT: '0', //折旧状态
                    SBXH: null,
                    GYSLXR: null, //供应商联系人
                    GYSDH: null, //供应商电话
                    WXLXR: null, //维修联系人
                    WXDH: null, //维修电话
                    GLLB: "3",
                    ZCBZ:'',//其他标志
                    RiskLevel:1,//风险等级
                    BYZD3:'0',//是否入账
                },
                AcceptInfo: [{ //资金来源原始数组
                    SBBH: null,
                    ZJLY: '1',
                    HH: '1',
                    name: '自筹资金',
                    JE: 0,
                    BZ: null
                }, {
                    SBBH: null,
                    ZJLY: '2',
                    HH: '2',
                    name: '科研经费',
                    JE: 0,
                    BZ: null
                }, {
                    SBBH: null,
                    ZJLY: '3',
                    HH: '3',
                    name: '教学经费',
                    JE: 0,
                    BZ: null
                }, {
                    SBBH: null,
                    ZJLY: '4',
                    HH: '4',
                    name: '接受捐赠',
                    JE: 0,
                    BZ: null
                }, {
                    SBBH: null,
                    ZJLY: '5',
                    HH: '5',
                    name: '财政项目拨款',
                    JE: 0,
                    BZ: null
                }, {
                    SBBH: null,
                    ZJLY: '6',
                    HH: '6',
                    name: '融资租赁',
                    JE: 0,
                    BZ: null
                }, {
                    SBBH: null,
                    ZJLY: '7',
                    HH: '7',
                    name: '财政基本拨款',
                    JE: 0,
                    BZ: null
                }]
            }
        },
        mounted() {
            this.$route.params.item ? this.loadDataDefault() : ''; //获取图片
        },
        methods: {
            loadDataDefault() { //资产修改加载资产
                this.$get('api/Property/GetEquipmentDefault', {
                    SBBH: this.$route.params.item.EquCode
                }).then(result => {
                    try {
                        result = JSON.parse(result);
                        this.data = result.Model[0];
                        for (let i = 0; i < result.ZJLY_Model.length; i++) { //循环赋值资金来源
                            let data = this.AcceptInfo.find(x => x.HH == result.ZJLY_Model[i].ZJLY)
                            data.JE = result.ZJLY_Model[i].JE;
                            data.BZ = result.ZJLY_Model[i].BZ;
                            data.SBBH = this.$route.params.item.EquCode;
                        }
                    } catch (e) {
                        this.$Toast('系统异常,请联系管理员!');
                    }
                })
            },
            save() { //提交资产修改
                if (!this.$verification(this.data, [{ //基本信息
                        id: 'SYKS',
                        name: '使用科室不能为空,请选择!'
                    }, {
                        id: 'MCBH',
                        name: '资产名称不能为空,请选择!'
                    }, {
                        id: 'SBZT',
                        name: '资产状态不能为空,请选择!'
                    }, {
                        id: 'CWKJKM',
                        name: '财务分类不能为空,请选择!'
                    }, {
                        id: 'ZCLY',
                        name: '资产来源不能为空,请选择!'
                    }])) {
                    this.selectIndex = 0;
                    this.$scrollscreen('.commonBox', 'start');
                    return false;

                };
                if (this.data.PJBZ === 'Y') { //附资产标志
                    if (!this.data.DDJXH && !this.data.DDJXHMC) {
                        this.$Toast('附资产标志开启状态下,请选择主资产');
                        //this.$scrollscreen('.commonBox', 'center');
                        this.selectIndex = 0;
                        return false;
                    }
                }

                if (!this.$verification(this.data, [{ //合同信息
                        id: 'HTJG',
                        name: '合同价格不能为空,请输入!'
                    }, {
                        id: 'QYRQ',
                        name: '启用日期不能,请选择!'
                    }, {
                        id: 'ZZRQ',
                        name: '保修到期不能为空,请选择!'
                    }])) {
                    this.selectIndex = 2;
                    this.$scrollscreen('.commonBox', 'start');
                    return false;
                };


                let ZJLYData = 0; //资金来源
                for (let i = 0; i < this.AcceptInfo.length; i++) {
                    ZJLYData += Number(this.AcceptInfo[i].JE);
                }
                if (this.data.HTJG != ZJLYData) {
                    this.$Toast({
                        message: `当前您填写的合同价格为${this.data.HTJG}元,资金来源总计为${ZJLYData}元,请重新输入!`,
                        onOpened: x => {
                            this.selectIndex = 3;
                            this.$scrollscreen('.commonBox', 'start');
                        },
                        duration: 2500,
                    })
                    return false;
                }

                if (this.data.ZJZT === '1') { //折旧信息
                    if (!this.$verification(this.data, [{ //折旧
                            id: 'ZJQD',
                            name: '启用折旧情况下,折旧起点不能为空!'
                        }, {
                            id: 'YJSYNX',
                            name: '启用折旧情况下,预计使用年限不能为空!'
                        }, {
                            id: 'KSZJRQ',
                            name: '启用折旧情况下,开始折旧日期不能为空!'
                        }])) {
                        this.$scrollscreen('.commonBox', 'start');
                        this.selectIndex = 4;
                        return false;
                    }
                }

                if (this.$route.params.item) { //新增Or修改
                    this.$post('api/Property/ModifyEeuipmenyDefault', {
                        EquipmentChild: this.data,
                        CapitalSource: this.AcceptInfo
                    }, 15000).then(result => {
                        if (result.Status) {
                            this.$Toast('修改成功!');
                            setTimeout(x => {
                                this.$router.back();
                            }, 1000)
                        } else this.$Toast('修改失败!');
                    })
                } else {
                    var data = this.data; //资产Model重组
                    data.BYZD4 = data.SFAZYS;
                    data.BYZD3 = data.BYZD3;
                    data.WXGS = data.WXGSMC;
                    data.SBCJ = data.SBCJMC;
                    data.SBPP = data.SBPPMC;
                    data.SBGB = data.SBGBMC;
                    data.SBCD = data.SBGBMC;
                    data.FPH = data.YWFP;
                    data.SL = 1;
                    var SBGL_ZJXXB = { //资产折旧信息
                        SBBH: this.data.SBBH,
                        CKH: '2',
                        HH: 1,
                        CWBH: '',
                        HTJG: this.data.HTJG,
                        ZJQD: this.data.ZJQD,
                        ZJNX: this.data.YJSYNX,
                        YJSYNX: this.data.YJSYNX,
                        YTQLFY: 0.00,
                        CZ: 0.00,
                        YJZGZL: 0.00,
                        DYGZL: 0.00,
                        YZJL: 0.00, //月折旧率
                        ZJZT: this.data.ZJZT,
                        KSZJRQ: this.data.KSZJRQ ? this.data.KSZJRQ : this.data.QYRQ,
                        ZJFS: '01',
                        GRRQ: this.data.GRRQ,
                        DJRQ: this.data.GRRQ,
                        BZ: this.data.ZJBZ,
                        ZT: 'Y',
                        XCZJRQ: this.data.QYRQ,
                        JCZL: 0.00,
                        JCZ: 0.00,
                        LJZJ: 0.00
                    };

                    this.$post('api/Property/AppendEquipemnt', {
                        Modelzjly: JSON.stringify(this.AcceptInfo),
                        Data1: JSON.stringify(data),
                        Data2: JSON.stringify(SBGL_ZJXXB),
                        SL: 1,
                        STORE: this.$UserInfo.StoreCode,
                        CKH: '2',
                        GKHM: this.$UserInfo.UserId,
                        WXFZR: this.data.WXFZR
                    }).then(result => {
                        if (result == "0" || result == "") {
                            this.$Toast("新增失败,详情请联系管理员!");
                        } else {
                            this.$Dialog.confirm({
                                title: '资产登记成功',
                                message: `科室:【${this.data.SYKSMC}】的资产编号[${result}]新增成功,请到资产综合查询查看`,
                                confirmButtonText: '查看'
                            }).then(() => {
                                this.$router.replace({
                                    name: 'PropertyDetails',
                                    params: {
                                        item: {
                                            EquCode: result
                                        },
                                        pageState: false
                                    }
                                })
                            }).catch(() => {
                                this.$router.back();
                            });
                        }
                    })
                }

            },
            ValueChange(index, obj) { //下拉框选择的时候
                if (index === 1) {
                    //设备状态
                    this.data.DLMC = obj.b;
                    this.data.SBZT = '1';
                    this.data.SBZTMC = '在用';

                    this.data.MCBH = obj.a;
                    this.data.SBMC = obj.b;
                    this.data.SBXH = obj.c;
                    this.data.SBDW = obj.d;
                    this.data.KJKM = obj.e;
                    this.data.KJKMMC = obj.f;
                    this.data.CWKJKM = obj.k;
                    this.data.CWKJKMMC = obj.l;
                } else if (index === 2) {
                    this.data.GYSBH = obj.a;
                    this.data.GYSMC = obj.b;
                    this.data.GYSLXR = obj.c;
                    this.data.GYSDH = obj.d;
                } else if (index === 3) {
                    this.data.WXGS = obj.a;
                    this.data.WXGSMC = obj.b;
                    this.data.WXLXR = obj.c;
                    this.data.WXDH = obj.d;
                }

            },
            ZJZTChange(obj) { //折旧状态更新的
                this.data.ZJZT = obj.id;
                if (obj.id === '0') {
                    this.$Toast('不启用折旧将不保存折旧信息');
                    this.data.KSZJRQ = null;
                    this.data.YJSYNX = null;
                }
            }
        },
        components: {
            Box,
            Field,
            Footer,
            [Cell.name]: Cell
        },
    }
</script>

<style scoped lang="scss">
    .EquipmentAcceptanceDetails {
        padding-bottom: 112px;
    }

    .tabs {
        display: flex;
        align-items: center;
        background: #45918A;
        border-radius: 14px 14px 0 0;
        position: fixed;
        z-index: 10;
        top: 105px;

        div {
            width: 142.5px;
            height: 96px;
            text-align: center;
            line-height: 96px;
            font-size: 28px;
            color: rgba(255, 255, 255, .7);
            border-radius: 14px 14px 0 0;
        }

        .action {
            color: $THEME-COLOR;
            background: #fff;
        }
    }

    .contentBox {
        margin-top: 85px;

        &>div {
            padding: 0 30px;
            border-radius: 14px;
            background: #fff;
            margin-bottom: 30px;

            &:first-child {
                border-radius: 14px;
            }
        }
    }

    .itemTitle {
        font-size: 30px;
        color: $TEXT-DARK-COLOR;
        margin: 38px 0;
    }

    .checkBox {
        &>div>div {
            height: 90px;
            border-bottom: 2px solid #f3f3f3;
            font-size: 28px;
            color: $TEXT-DARK-COLOR;
        }
    }

    .firstBox {
        padding-bottom: 20px !important;
    }

    .firstBox>div:last-child {
        padding: 0;
    }

    .secondBox {
        .title {
            font-size: 32px;
            color: $TEXT-DARK-COLOR;
            font-weight: bold;
            padding-top: 44px;
        }
    }

    .fourthly {
        padding: 34px 36px 12px !important;
    }

    .fourthlyItems {
        margin-bottom: 36px;

        div {
            display: flex;
            align-items: center;
            margin-bottom: 12px;

            span:first-child {
                flex: 1;
                font-size: 30px;
                color: $TEXT-DARK-COLOR;
            }

            span:last-child {
                font-size: 28px;
                color: $TEXT-DARK-COLOR;
                margin-left: 10px;
            }

            input {
                width: 40vw;
                font-size: 32px;
                font-weight: bold;
                text-align: right;

                &::-webkit-input-placeholder {
                    color: #858585;
                    font-size: 28px;
                    font-weight: 400;
                }
            }
        }

        &>input {
            width: 650px;
            height: 88px;
            background: #F3F3F3;
            border-radius: 12px;
            font-size: 26px;
            text-indent: 32px;

            &::-webkit-input-placeholder {
                color: #858585;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/propertyEditDefault/propertyEditDefault.vue